import type { GetObligationInternalAuditResultByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetObligationInternalAuditResultByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationInternalAuditResultByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetObligationInternalAuditResultByIdArgs = {
  id: string;
};

export const useGetObligationInternalAuditResultById = createQueryHook<
  UseGetObligationInternalAuditResultByIdArgs,
  GetObligationInternalAuditResultByIdResponseRow[],
  GetObligationInternalAuditResultByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.internalAuditResult.obligationInternalAuditResultById.queryOptions(
      { id }
    ),
  mapTrpcDataToGraphQL: (data) => ({
    obligation_internal_audit_result: data,
  }),
  graphqlDocument: GetObligationInternalAuditResultByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
